var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"clubs"}}),_c('CrudList',{attrs:{"tableName":"club","tableNamePlural":"clubs","defaultSort":"reg_num","queryParams":"?join=church","columns":_vm.columns,"dataModifier":_vm.dataModifier}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }